define((require) => {
    "use strict";

    const SceneViewer = require("shared/ui/viewer/SceneViewer");

    /**
     * A <tt>SceneViewer</tt> used for preview in the editor, supporting zooming.
     *
     * @class PreviewSceneViewer
     *
     * @see ExperiencePreview
     * @see PreviewExperienceViewer
     */
    return SceneViewer.extend({

        /**
         * @override
         */
        _calculateWidgetRect(widget) {
            // Compensate for the current zoom scale in editor preview.
            const zoomModel = this.options.zoomModel;

            return widget.getBoundingBox().scale(zoomModel.get("scale"));
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/PreviewSceneViewer.js